@if (previewContext) {
	<app-ts1-rating-preview-summary
		[candidateNames]="previewContext.candidateNames"
		[candidateCrewRoles]="previewContext.candidateCrewRoles"
		[candidateIds]="previewContext.candidateIds"
		[maneuverOutcomes]="previewContext.maneuverOutcomes"
		[temCompetencyOutcomes]="previewContext.temCompetencyOutcomes"
		[signOffForm]="previewContext.signOffForm"
		[hideCandidateNav]="true"
		[hideFooter]="true"
		[embedded]="true"
		[competencyBlocksForIndex]="ts1BlocksForIndex"
		[maneuverRowsForIndex]="ts1RowsForIndex"
		[summaryCommentsForIndex]="ts1CommentsForIndex"
		[competencyObCommentsForIndex]="ts1ObCommentsForIndex"
		[traineeAssessmentIdForIndex]="ts1TraineeAssessmentIdForIndex"
		[candidateDetailsForIndex]="ts1DetailsForIndex"
		[reminderNotesEnabled]="ts1ReminderNotesEnabled()"
		[useStructuredReminderNotes]="ts1StructuredReminderNotesEnabled()"
		[initialCandidateIndex]="embeddedPreviewCandidateIndex"
	></app-ts1-rating-preview-summary>

	<div class="my-4 h-0.5 w-full bg-[#CFE3FF]"></div>

	<div class="mt-6 grid grid-cols-2 gap-8 p-8">
		<div class="space-y-8">
			<div class="form-display flex flex-col gap-2">
				<label class="form-label">Instructor Name</label>
				<div class="form-value">
					{{ reportSummary?.sessionDetails?.instructorName }}
				</div>
			</div>
			<div class="form-display flex flex-col gap-2">
				<label class="form-label">License Number</label>
				<div class="form-value">
					{{ reportSummary?.examinerNumber ?? "-" }}
				</div>
			</div>
		</div>
		<div class="form-display flex flex-col gap-2">
			<label class="form-label">Instructor Signature</label>
			<div class="flex h-24 w-72 flex-col items-center gap-4 bg-[#F6FAFF]">
				@if (instructorSignature) {
					<img [src]="instructorSignature" alt="Signature" class="h-full" />
				}
				<span class="text-sm font-medium">{{ instructorSignOffDate }}</span>
			</div>
		</div>
	</div>

	<div class="my-4 h-0.5 w-full bg-[#CFE3FF]"></div>

	<div class="grid grid-cols-2 gap-8 p-8">
		<div>
			<div class="form-display flex flex-col gap-2">
				<label class="form-label">Candidate name</label>
				<div class="form-value">
					{{ reportSummary?.candidateDetails?.name }}
				</div>
			</div>
		</div>

		<div class="form-display flex flex-col gap-2">
			<label class="form-label">Candidate Signature</label>
			<div class="flex h-24 w-72 flex-col items-center gap-4 bg-[#F6FAFF]">
				@if (candidateSignature) {
					<img [src]="candidateSignature" alt="Signature" class="h-full" />
				}
				<span class="text-sm font-medium">{{ candidateSignOffDate }}</span>
			</div>
		</div>
	</div>
}
